<template>
  <el-tooltip
    :content="content"
    placement="top"
    :disabled="disabled"
    popper-class="tooltip-text-popper"
  >
    <div ref="tooltipConent" class="text-truncate">
      <span ref="tooltipText">
        {{ content || '' }}
      </span>
    </div>
  </el-tooltip>
</template>

<script>
export default {
  name: 'tooltip-text',
  props: {
    content: { type: String, default: '' },
  },
  data() {
    return { disabled: false, timer: null }
  },
  mounted() {
    this.loading()
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
  watch: {
    content: {
      handler() {
        this.loading()
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    loading() {
      this.$nextTick(() => {
        const contentEl = this.$refs.tooltipConent
        const textEl = this.$refs.tooltipText

        if (!contentEl || !textEl) {
          this.timer = setTimeout(() => this.loading(), 1000)
          return
        }

        const textWidth = textEl.offsetWidth
        const contentWidth = contentEl.offsetWidth
        this.disabled = textWidth <= contentWidth
      })
    },
  },
}
</script>

<style lang="scss">
.tooltip-text-popper {
  max-width: 300px;
}
</style>
